document.addEventListener('DOMContentLoaded', function () {
  const widget = document.getElementById('bundle-widget');
  if (!widget) return;

  const checkboxes = widget.querySelectorAll('.bundle-checkbox');
  const totalPriceEl = document.getElementById('bundle-total-price');
  const comparePriceEl = document.getElementById('bundle-total-compare-price');
  const addButton = document.getElementById('bundle-add-to-cart');
  const messageEl = document.getElementById('bundle-message');

  function formatPrice(cents) {
    return 'Rs. ' + (cents / 100).toFixed(0);
  }

  function updateTotal() {
    let total = 0;
    let compareTotal = 0;
    let selectedCount = 0;

    checkboxes.forEach(function (cb) {
      if (cb.checked) {
        total += parseInt(cb.dataset.price, 10);
        compareTotal += parseInt(cb.dataset.comparePrice || cb.dataset.price, 10);
        selectedCount++;
      }
    });

    totalPriceEl.textContent = formatPrice(total);

    if (compareTotal > total) {
      comparePriceEl.textContent = formatPrice(compareTotal);
      comparePriceEl.style.display = 'inline';
    } else {
      comparePriceEl.style.display = 'none';
    }

    addButton.disabled = selectedCount < 2;
  }

  checkboxes.forEach(function (cb) {
    cb.addEventListener('change', updateTotal);
  });

  updateTotal();

  addButton.addEventListener('click', function () {
    const items = [];

    checkboxes.forEach(function (cb) {
      if (cb.checked) {
        items.push({
          id: parseInt(cb.dataset.variantId, 10),
          quantity: 1
        });
      }
    });

    if (items.length < 2) return;

    addButton.disabled = true;
    addButton.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function () {
        messageEl.textContent = 'Bundle added to cart!';
        messageEl.style.color = 'green';
        addButton.textContent = 'Add Bundle to Cart';
        addButton.disabled = false;
      })
      .catch(function () {
        messageEl.textContent = 'Kuch masla hua, dobara try karein.';
        messageEl.style.color = 'red';
        addButton.textContent = 'Add Bundle to Cart';
        addButton.disabled = false;
      });
  });
});